import React, { useMemo, useState } from 'react';
import {
  Box,
  TextField,
  List,
  ListItem,
  ListItemText,
  Button,
  InputAdornment,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Chip,
  Tooltip
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import DashboardCard from '../../shared/DashboardCard';
import { useNavigate } from 'react-router';
import { School } from '@mui/icons-material';

const TownWiseAvailability = ({ townData, country }) => {
  const [view, setView] = useState('university');
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      setView(newView);
    }
  };
  const handleExplore = (provinceId,name) => {
    navigate(`/explore?university=${provinceId}&country=${country}&universityName=${name}`);
  };
  console.log("townData",townData);
  const EmptyState = () => (
    <Box
        sx={{
          p: { xs: 2, sm: 3 },
          minHeight: { xs: 180, sm: 200 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px dashed',
          borderColor: 'divider',
          borderRadius: 1
        }}
    >
      <School sx={{ 
      fontSize: { xs: 36, sm: 48 }, 
      color: 'text.secondary', 
      mb: { xs: 1, sm: 2 } 
    }} />
      <Typography variant="h6" color="text.secondary" gutterBottom
            sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}
      >
        No Universities Found
      </Typography>
      <Typography variant="body2" color="text.secondary" align="center"
            sx={{ fontSize: { xs: '1rem', sm: '0.8rem' } }}

      >
        There are no universities available for this selection.
      </Typography>
    </Box>
  );
  const filteredItems = useMemo(() => {
    if (!searchTerm.trim()) return townData;
    
    const searchStr = searchTerm?.toLowerCase();
    return townData.filter(item => 
      item.collegeName?.toLowerCase().includes(searchStr)
    );
  }, [searchTerm, townData]);

  return (
    <DashboardCard 
      // title=""
      sx={{ p: { xs: 0, sm: 3 } }}
    >
      <Typography variant="h5"
                        sx={{ 
                          fontSize: { xs: '1.1rem', sm: '1.25rem' },
                          mb: 2
                        }}
      >Availability By University</Typography>
      <Box sx={{ mb: { xs: 2, sm: 2 } }}>
        <TextField
          fullWidth
          placeholder={`Search ${view}...`}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }} />
              </InputAdornment>
            ),
          }}
          size="small"
          sx={{ 
            '& .MuiInputBase-root': { 
              fontSize: { xs: '0.875rem', sm: '1rem' } 
            } 
          }}
        />
      </Box>
  
      <List sx={{ 
        maxHeight: { xs: '300px', sm: '400px' },
        overflow: 'auto',
        msOverflowStyle: { xs: 'none', sm: 'auto' }, // Hide scrollbar IE/Edge
        scrollbarWidth: { xs: 'none', sm: 'thin' }, // Hide scrollbar Firefox
        '&::-webkit-scrollbar': {
          width: { xs: 0, sm: '6px' }, // Hide scrollbar Chrome/Safari/Opera
          display: { xs: 'none', sm: 'block' }
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'divider',
          borderRadius: '3px',
          display: { xs: 'none', sm: 'block' }
        }
      }}>
        {filteredItems?.length === 0 ? (
          <EmptyState />
        ) : (
          filteredItems?.map((item) => (
            <ListItem
              key={item.collegeId}
              sx={{
                mb: { xs: 1, sm: 1.5 },
                p: { xs: 1.5, sm: 2 },
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                flexDirection: { xs: 'column', sm: 'row' },
                gap: { xs: 1, sm: 0 },
                alignItems: { xs: 'stretch', sm: 'center' }
              }}
            >
              <ListItemText
                primary={
                  <Box display="flex" 
                       alignItems="center" 
                       gap={1}
                       flexWrap="wrap"
                  >
                    <Tooltip title={item.collegeName}>
                      <Typography
                        variant="subtitle1"
                        fontWeight="medium"
                        sx={{
                          maxWidth: { xs: '100%', sm: 150 },
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          fontSize: { xs: '0.875rem', sm: '1rem' }
                        }}
                      >
                        {item.collegeName}
                      </Typography>
                    </Tooltip>
                    {/* <Chip
                      label="Active"
                      size="small"
                      color="primary"
                      variant="outlined"
                      sx={{ 
                        height: { xs: 20, sm: 24 },
                        '& .MuiChip-label': {
                          fontSize: { xs: '0.75rem', sm: '0.875rem' }
                        }
                      }}
                    /> */}
                  </Box>
                }
                secondary={
                  <Typography 
                    variant="body2" 
                    color="text.secondary"
                    sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                  >
                    {item.bedSpaces} Bedspaces | {item.properties} Properties
                  </Typography>
                }
                sx={{ mb: { xs: 1, sm: 0 } }}
              />
              <Button 
                variant="contained" 
                color="primary" 
                size="small"
                onClick={() => handleExplore(item?.collegeId, item.collegeName)}
                sx={{
                  width: { xs: '100%', sm: 'auto' },
                  py: { xs: 0.5, sm: 1 }
                }}
              >
                Explore
              </Button>
            </ListItem>
          ))
        )}
      </List>
    </DashboardCard>
  );
};

export default TownWiseAvailability;